// Auto-generated icon bundle index
// This file is generated by scripts/extract-icons.js

import iconoir from './iconoir.json'

export const iconSets = {
  iconoir: iconoir,
}

export function getIconData(iconName: string) {
  const [prefix, name] = iconName.split(':')
  const iconSet = iconSets[prefix as keyof typeof iconSets]

  if (!iconSet) {
    console.warn(`Icon set ${prefix} not found`)
    return null
  }

  const body =
    iconSet.icons[name as keyof typeof iconSet.icons]?.body ??
    iconSet.icons[
      iconSet.aliases[name as keyof typeof iconSet.aliases]?.parent as keyof typeof iconSet.icons
    ]?.body

  if (!body) {
    console.warn(`Icon ${iconName} not found in bundle`)
    return null
  }

  return {
    body,
    width: iconSet.width,
    height: iconSet.height,
  }
}
